import { render, staticRenderFns } from "./AiIcon.vue?vue&type=template&id=00b43f94&scoped=true&"
import script from "./AiIcon.vue?vue&type=script&lang=js&"
export * from "./AiIcon.vue?vue&type=script&lang=js&"
import style0 from "./AiIcon.vue?vue&type=style&index=0&id=00b43f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b43f94",
  null
  
)

export default component.exports